import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    width:100vh;
    height:35rem;
    flex-direction: column;
    pointer-events: auto;

    ${({ loading }) => loading &&
        css`
            pointer-events: none;
        `
    }
`
export const Content = styled.div`
    display: flex;
    flex-direction: row;
    height: calc(100% - 4rem);
    padding: 0.5rem;

`
export const Parameters = styled.div`
    display: flex;
    width: 40%;
    height: 100%;
    padding: 0.5rem;
    flex-direction: column;
`
export const DescriptionText = styled.div`
    display: flex;
    width: 60%;
    height: 100%;
    padding: 0.5rem;
    flex-direction: column;
`
export const Title = styled.div`
    display: flex;
    height: 4rem;
    justify-content:center;
    p{
        font-size: 2rem;
        font-weight: 400;
        color: #000000;
        height: 1.2rem;
    } 
`
export const Card = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 6px;
    background-color: #fff;
    padding: 1rem;
    box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
    white-space: break-spaces;
    overflow-y:auto;
    user-select: all;
    &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
    }
`
export const ContentConfig = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 1rem;
    overflow-y:auto;
    &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
    }
`
export const Config = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    min-height: 4rem;
    padding: 0.4rem;
    span{
        position: absolute;
        top:-1px;
        font-size: 0.8rem;
        margin-left: 1rem;
        background-color: #ffffff;
    }
    .group{
        display: flex;
        width: 100%;
        flex-direction: column;
        border-radius: 4px;
        border: 1px solid #c2c2c2;
        justify-content: center;
        padding: 0 1rem 0 1rem;
        input{
            outline: none;
            border: none;
            background-color: transparent;
        }
    }
`

export const Footer = styled.div`
    display: flex;
    width: 100%;
    height: 4rem;
    padding: 1rem;
    justify-content: right;
    align-items: center;
    button{
        display: flex;
        border: none;
        outline: none;
        width: 10rem;
        height: 2rem;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        cursor: pointer;
        background-color: #1D86FF;
        color: #ffffff;
        transition: filter 0.1s;
        transition: all 0.7s ease;
        &:hover{
            filter: brightness(0.97);
        }
        ${({ loading }) => loading &&
        css`
                width: 4rem;
                pointer-events: none;
            `
    }
    }
`
export const Load = styled.div`
    border: 2px solid #fff; 
    border-top: 2px solid #b5b5b500; 
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
    margin-left: 2px;
  
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`